import moment from 'moment';

/**
 * Normalize date to YYYY-MM-DD format for comparison
 */
export const normalizeDate = (date) => {
    if (!date) return null;
    // If it's already a string in YYYY-MM-DD format, return it
    if (typeof date === 'string') {
        const trimmed = date.trim();
        // Check if it matches YYYY-MM-DD format
        if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
            return trimmed.substring(0, 10); // Take only YYYY-MM-DD part
        }
        // Try to parse as date string
        const parsed = moment(trimmed);
        if (parsed.isValid()) {
            return parsed.format('YYYY-MM-DD');
        }
        return trimmed;
    }
    // If it's a Date object or moment, format it
    if (date instanceof Date || moment.isMoment(date)) {
        return moment(date).format('YYYY-MM-DD');
    }
    // Try to parse as date
    const parsed = moment(date);
    if (parsed.isValid()) {
        return parsed.format('YYYY-MM-DD');
    }
    return String(date).trim();
};

/**
 * Format date to DD.MM.YYYY
 */
export const formatDate = (date) => {
    return moment(date).format('DD.MM.YYYY');
};

/**
 * Generate date columns for the selected range
 */
export const getDateColumns = (startDateMoment, endDateMoment) => {
    if (!startDateMoment || !endDateMoment) return [];
    
    const columns = [];
    const current = startDateMoment.clone();
    const today = moment();
    
    // If we're viewing the current month, limit to today
    const endDate = endDateMoment.clone();
    if (startDateMoment.isSame(today, 'month') && endDateMoment.isSame(today, 'month')) {
        // We're viewing the current month, so limit to today
        endDate.set(today);
    }
    
    while (current.isSameOrBefore(endDate, 'day')) {
        columns.push({
            date: current.clone(),
            dateKey: current.format('YYYY-MM-DD'),
            displayDate: current.format('DD.MM.YYYY'),
            shortDate: current.format('DD.MM')
        });
        current.add(1, 'day');
    }
    
    return columns;
};

/**
 * Filter dates to only allow selection within the same month
 */
export const createDateFilter = (startDateMoment, endDateMoment) => {
    return (date) => {
        // If no start date selected, allow all dates (user is selecting start date)
        if (!startDateMoment) {
            return true;
        }
        
        // If both dates are selected, allow all dates (user can reset and select new start date)
        if (startDateMoment && endDateMoment) {
            return true;
        }
        
        // If only start date is selected, restrict end date to same month
        const dateMoment = moment(date);
        return dateMoment.month() === startDateMoment.month() && 
               dateMoment.year() === startDateMoment.year();
    };
};

